import { styled } from "@linaria/react";
import { createPortal } from "react-dom";
import { useState, useEffect, useRef, useLayoutEffect } from "react";
import ReactPlayer from "react-player";
const Container = /*#__PURE__*/styled("div")({
  name: "Container",
  class: "c1hjeb5"
});
/**
 * Element used for centering video (though it will be off slightly on mobile)
 */

const Center = /*#__PURE__*/styled("div")({
  name: "Center",
  class: "ce7qffr"
});
/**
 * Responsive iframe resize container
 */

const Content = /*#__PURE__*/styled("div")({
  name: "Content",
  class: "c1s9jpuk"
});
const Frame = /*#__PURE__*/styled("div")({
  name: "Frame",
  class: "f6bodmc"
});

function Video({
  hide
}: {
  hide: () => void;
}): JSX.Element | null {
  useLayoutEffect(() => {
    const handler = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        hide();
      }
    };

    document.addEventListener("keydown", handler);
    return () => {
      document.removeEventListener("keydown", handler);
    };
  }, [hide]);
  const ref = useRef<Element>();
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    const element = document.querySelector("#modal");

    if (!element) {
      return;
    }

    ref.current = element;
    setMounted(true);
  }, []);

  if (!mounted || !ref.current) {
    return null;
  }

  return createPortal(<>
      <Container onClick={hide}>
        <Center>
          <Content>
            <Frame onClick={event => event.stopPropagation()}>
              <ReactPlayer width="100%" height="100%" url="/assets/teaser.mp4" playing controls />
            </Frame>
          </Content>
        </Center>
      </Container>
    </>, ref.current);
}

export default Video;

require("../../../.linaria-cache/src/components/video/index.linaria.module.css");